window.addEventListener("DOMContentLoaded", () => {
  const timeline = {
    init: function() {
      const timelines = document.querySelectorAll('[data-timeline]');

      timelines.forEach((timeline) => {
        const targets = timeline.querySelectorAll('[data-timeline-item]');
        
        const threshold = 0.5;
        const ANIMATED_CLASS = 'in-view';

        function callback(entries, observer) {
          entries.forEach((entry) => {
            const elem = entry.target;
            if (entry.intersectionRatio >= threshold) {
              elem.classList.add(ANIMATED_CLASS);
              observer.unobserve(elem);
            }
          });
        }

        const observer = new IntersectionObserver(callback, { threshold });
        for (const target of targets) {
          observer.observe(target);
        }
      });
    },
  };

    timeline.init();
});
